export const ProgressBar = ({ v, mx, l, color, c }) => {
  const p = mx > 0 ? Math.min(100, Math.max(0, (v / mx) * 100)) : 0;
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
        <span style={{ fontSize: 13, color: c.muted }}>{l}</span>
        <span style={{ fontSize: 13, fontWeight: 600, fontVariantNumeric: "tabular-nums", color: c.fg }}>{Math.round(p)}%</span>
      </div>
      <div style={{ height: 4, borderRadius: 2, background: c.border, overflow: "hidden" }}>
        <div style={{
          height: "100%", borderRadius: 2, background: color || c.blue,
          width: p + "%", transition: "width 0.6s cubic-bezier(0.25,0.1,0.25,1)",
        }} />
      </div>
    </div>
  );
};
